/* Global imports. */
import React from "react";
import { Link } from "gatsby";

/* Class imports. */
import Breadcrumb from "@classes/Breadcrumb";

interface Props {
  breadcrumbs: Array<Breadcrumb>;
}

const Breadcrumbs = ({ breadcrumbs }: Props) => (
  /* TODO: <section> needs to be <nav> once the styles have been stripped out. */
  <section>
	<div className="flex -scale-x-100 overflow-x-auto overflow-y-hidden custom-scroll">
      <ol id="breadcrumbs" className="-scale-x-100 whitespace-nowrap flex flex-grow flex-nowrap items-center my-4 !ml-0 !list-none">
        {breadcrumbs.map((breadcrumb, index) => (
          breadcrumb.url && breadcrumb.label && 
          <li key={`bc-${index}`} className="flex items-center relative ml-4 pl-4 font-sans text-xs after:content-['/'] after:text-grey-light after:absolute after:left-0 first:ml-0 first:pl-0 first:after:content-none after:pointer-events-none">
            <span className={`absolute left-0 hide-selection ${index === 0 ? "hidden" : ""}`}>&nbsp;</span>
            {index !== breadcrumbs.length - 1 ? (
              <Link
                className={`select-none ${index === breadcrumbs.length - 1 ? "text-grey-dark underline decoration-solid" : "no-underline text-grey-light"} hover:underline hover:decoration-solid hover:text-grey-dark line-clamp-1`}
                to={breadcrumb.url}
              >
                {breadcrumb.label}
              </Link>
            ) : (
              <span className="text-grey-dark line-clamp-1 underline cursor-auto">{breadcrumb.label}</span>
            )}
          </li>
        ))}
      </ol>
	</div>
  </section>
);

export default Breadcrumbs;
